import $axios from '@/store/axios-instance.js';

export default {
    state: {
        clientSuspendHistoryList: null,
    },
    mutations: {
        retrieveClientSuspendHistory(state, payload) {
            state.clientSuspendHistoryList = payload
        },
        insertClientSuspendHistory(state, entity) {
            state.clientSuspendHistoryList.push(entity)
        },
        updateClientSuspendHistory(state, payload) {
            let entity = state.clientSuspendHistoryList.find(function (item) {
                return item.id === payload.id
            })

            Object.assign(entity, payload);
        },
        deleteClientSuspendHistory(state, entity) {
            let entityIndex = state.clientSuspendHistoryList.findIndex(function (item) {
                return item.id === entity
            })
            if (entityIndex > -1) {
                state.clientSuspendHistoryList.splice(entityIndex, 1)
            }
        },
    },
    actions: {
        retrieveClientSuspendHistory(context) {
            return new Promise((resolve, reject) => {
                if (!context.getters.currentClient) {
                    context.commit('retrieveClientSuspendHistory', null)
                    resolve()
                } else {
                    $axios
                        .get(`clients/${context.getters.currentClient.id}/suspendHistory`)
                        .then(response => {
                            context.commit('retrieveClientSuspendHistory', response.data)

                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                }
            })
        },
        setClientSuspendHistory(context, payload) {
            return new Promise((resolve, reject) => {
                if (!payload.isUpdate) { //insert
                    try {
                        $axios
                            .post(`clients/${context.getters.currentClient.id}/suspendHistory`, {
                                startDate: payload.startDate,
                                endDate: payload.endDate,
                                description: payload.description
                            })
                            .then((response) => {
                                context.commit('insertClientSuspendHistory', response.data)
                                resolve(payload)
                            })
                            .catch(error => {
                                console.log(error)
                                reject(error)
                            })
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                } else { //update
                    try {
                        $axios
                            .put(`clients/${context.getters.currentClient.id}/suspendHistory/${payload.id}`, {
                                startDate: payload.startDate,
                                endDate: payload.endDate,
                                description: payload.description
                            })
                            .then((response) => {
                                context.commit('updateClientSuspendHistory', response.data)
                                resolve(payload)
                            })
                            .catch(error => {
                                console.log(error)
                                reject(error)
                            })
                    } catch (error) {
                        console.log(error)
                        reject(error)
                    }
                }
            })
        },
        deleteClientSuspendHistory(context, payload) {
            return new Promise((resolve, reject) => {
                try {
                    $axios
                        .delete(`clients/${context.getters.currentClient.id}/suspendHistory/${payload}`)
                        .then(() => {
                            context.commit('deleteClientSuspendHistory', payload)
                            resolve()
                        })
                        .catch(error => {
                            console.log(error)
                            reject(error)
                        })
                } catch (error) {
                    console.log(error)
                    reject(error)
                }
            })
        },
    },
    getters: {
        clientSuspendHistoryList(state) {
            return state.clientSuspendHistoryList ?? []
        },
    }
}